// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Loading from "../../../../components/loading/Loading";
import {BiArrowBack} from "react-icons/bi";
import {addJobRequestTransaksiSelector, getJobRequestDetail, getQuatationByUser,} from "./AddjobRequestTransaksiSlice";
import {maxPageGlobal} from "../../../../assets/config";
import {updateJobRequestTransaksi} from "./jobRequestTransaksiSlice";

function isRequired(value) {
    let status = false;
    if (value !== null) {
        if (typeof value === "number") {
            if (value !== -1) {
                status = true;
            }
        }

    }
    return status;
}

function useForm(initialState = {}, validations = [], onSubmit = () => {
}) {
    const {isValid: initialIsValid, errors: initialErrors} = validate(
        validations,
        initialState
    );
    const [changed, setChanged] = useState(false);
    const [values, setValues] = useState(initialState);
    const [errors, setErrors] = useState(initialErrors);
    const [isValid, setValid] = useState(initialIsValid);
    const [touched, setTouched] = useState({});

    const changeHandler = (event) => {
        const newValues = {...values, [event.target.name]: event.target.value};
        const {isValid, errors} = validate(validations, newValues);
        setChanged(true);
        setValues(newValues);
        setValid(isValid);
        setErrors(errors);
        setTouched({...touched, [event.target.name]: true});
    };

    const changeHandlerActivity = (data) => {
        const newValues = {...values, Activity: data};
        const {isValid, errors} = validate(validations, newValues);
        setChanged(true);
        setValues(newValues);
        setValid(isValid);
        setErrors(errors);
    };

    const editHandler = (initValues) => {
        const newValues = {
            ...values,
            QuatationNo: initValues.QuatationNo,
            QuatationParent: initValues.QuatationParent,
            SPKNo: initValues.SPKNo,
            KlienID: initValues.KlienID,
            Priority: initValues.Priority,
            StatusKet: initValues.StatusKet,
            Activity: initValues.Activity,
            WSBNo: initValues.WSBNo,
            ShippingManifest: initValues.ShippingManifest,
        };
        setValues(newValues);
    };

    const clearHandler = () => {
        setValues(initialState);
    };

    const submitHandler = (event) => {
        event.preventDefault();
        onSubmit(values);
    };
    return {
        values,
        changeHandler,
        editHandler,
        clearHandler,
        isValid,
        errors,
        touched,
        submitHandler,
        changeHandlerActivity,
    };
}

function validate(validations, values) {
    const errors = validations
        .map((validation) => validation(values))
        .filter((validation) => typeof validation === "object");
    return {
        isValid: errors.length === 0,
        errors: errors.reduce((errors, error) => ({...errors, ...error}), {}),
    };
}

const JobRequestPage = ({}) => {
    const jobRequest = useSelector(addJobRequestTransaksiSelector);
    let initialState = {
        QuatationNo: "",
        SPKNo: "",
        Priority: "",
        KlienID: "",
        StatusKet: "",
        Activity: [],
    };

    const param = useLocation();

    const validations = [
        ({QuatationNo}) =>
            isRequired(QuatationNo) || {QuatationNo: "Nomor Quatation wajib diisi"},
        ({SPKNo}) => isRequired(SPKNo) || {SPKNo: "Nomor SPK wajib diisi"},
        ({Priority}) =>
            isRequired(Priority) || {Priority: "Priority wajib diisi"},
        ({KlienID}) => isRequired(KlienID) || {KlienID: "ID Klien wajib diisi"},
    ];

    const {
        values,
        errors,
        touched,
        changeHandler,
        editHandler,
        changeHandlerActivity,
    } = useForm(initialState, validations);
    const [buttonTouched, setButtonTouched] = useState(false);
    const quatation = useSelector(addJobRequestTransaksiSelector);
    const [IncomingDate, setIncomingDate] = useState(new Date());

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [Tanggal, setTanggal] = useState("");
    const [isValidTanggal, setIsValidTanggal] = useState(true);
    const [dateChanged, setDateChanged] = useState(false);
    const [checkListChanged, setCheckListChanged] = useState(false);
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(maxPageGlobal);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState("");
    const [searchFetch, setSearchFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [Quatation, setQuatation] = useState([]);
    const [indexSelected, setindexSelected] = useState(-1);

    const [insertFetch, setInsertFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const [jobRequestList, setjobRequestList] = useState([]);

    const [checkedState, setCheckedState] = useState(
        new Array(jobRequestList.length).fill(false)
    );

    const [checkedStateDetail, setCheckedStateDetail] = useState(
        new Array(jobRequestList.length).fill(false)
    );

    const handleOnChange = (position) => {
        const updatedCheckedState = checkedState.map((item, index) =>
            index === position ? !item : item
        );

        setCheckedState(updatedCheckedState);
    };

    const inputArray = [
        {
            type: "text",
            id: 1,
            value: "",
        },
    ];

    function handleInsertJR() {
        let sendArray = {
            ...values,
            Activity: values.Activity,
            Date: new Date(Tanggal),
            JRID: jobRequest.isDataDetailEdit.JRID,
            IncomingDate: new Date(IncomingDate),
        };
        console.log(sendArray)
        dispatch(updateJobRequestTransaksi(sendArray));
    }

    useEffect(() => {
        dispatch(getQuatationByUser());
        dispatch(getJobRequestDetail({JRID: param.state.JRID}));
    }, []);

    useEffect(() => {
        if (jobRequest.isGetEditDetailSuccess && !firstLoading) {
            if (jobRequest.isGetSuccess) {
                setQuatation(jobRequest.data);
            }

            if (jobRequest.isGetEditDetailSuccess) {
                editHandler(jobRequest.isDataDetailEdit);
            }
            if (values.Activity.length === 0) {
                changeHandlerActivity(jobRequest.isDataDetailEdit.Activity);
            }
            if (quatation.data) {
                const x = quatation.data.findIndex(
                    (x) => x.QuatationNo === jobRequest.isDataDetailEdit.QuatationNo
                );
                setindexSelected(x);
            }
            const initValues = {
                QuatationNo: jobRequest.isDataDetailEdit.QuatationNo,
                SPKNo: jobRequest.isDataDetailEdit.SPKNo,
                Priority: jobRequest.isDataDetailEdit.Priority,
                KlienID: jobRequest.isDataDetailEdit.KlienID,
                StatusKet: jobRequest.isDataDetailEdit.StatusKet,
                Activity: jobRequest.isDataDetailEdit.Activity,
                NoWBS: jobRequest.isDataDetailEdit.NoWBS,
                WSBNo: jobRequest.isDataDetailEdit.WSBNo,
                ShippingManifest: jobRequest.isDataDetailEdit.ShippingManifest,
                QuatationParent: jobRequest.isDataDetailEdit.QuatationParent
            };


            editHandler(initValues);
            setTanggal(
                new Date(
                    new Date(
                        jobRequest?.isDataDetailEdit && jobRequest?.isDataDetailEdit.Date
                    )
                )
            );

            setIncomingDate(
                new Date(
                    new Date(
                        jobRequest?.isDataDetailEdit &&
                        jobRequest?.isDataDetailEdit.IncomingDate
                    )
                )
            );

            setFirstLoading(true);
        }
    });
    if (!firstLoading) {
        return <Loading/>;
    } else {
        return (
            <>
                <div className="md border m-4 rounded divide-y">
                    <div className="flex w-full justify-end p-4 flex-col sm:flex-row pt-4">
                        <button
                            onClick={() => navigate("/")}
                            className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
                        >
                            <BiArrowBack className="text-xl text-gray-800 pr-2"/>
                            Kembali
                        </button>
                        <button
                            onClick={() => handleInsertJR()}
                            className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
                        >
                            Simpan
                        </button>
                    </div>
                    <div className="px-4 py-4">
                        <div className="flex flex-wrap -mx-3 mb-6">
                            <div className="w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                    Nomor Quatation
                                </label>
                                <div className="inline-block relative w-full">
                                    <input
                                        disabled={true}
                                        value={values.QuatationNo}
                                        onChange={changeHandler}
                                        name="SPKNo"
                                        className={
                                            (touched.SPKNo || buttonTouched) && errors.SPKNo
                                                ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        }
                                        type="text"
                                    />
                                </div>
                                {(touched.QuatationNo || buttonTouched) &&
                                    errors.QuatationNo && (
                                        <p className="text-red-500 text-xs italic">
                                            {errors.QuatationNo}
                                        </p>
                                    )}
                            </div>
                            <div className="w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                    Additional Quatation
                                </label>
                                <input
                                    disabled={true}
                                    value={values.QuatationParent}
                                    name="SPKNo"
                                    className={
                                        (touched.SPKNo || buttonTouched) && errors.SPKNo
                                            ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                            : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                    }
                                    type="text"
                                />
                                {(touched.SPKNo || buttonTouched) && errors.SPKNo && (
                                    <p className="text-red-500 text-xs italic">{errors.SPKNo}</p>
                                )}
                            </div>

                        </div>
                        <div className="flex flex-wrap -mx-3 mb-6">
                            <div className="w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                    Nomor SPK
                                </label>
                                <input
                                    value={values.SPKNo}
                                    onChange={changeHandler}
                                    name="SPKNo"
                                    className={
                                        (touched.SPKNo || buttonTouched) && errors.SPKNo
                                            ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                            : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                    }
                                    type="text"
                                />
                                {(touched.SPKNo || buttonTouched) && errors.SPKNo && (
                                    <p className="text-red-500 text-xs italic">{errors.SPKNo}</p>
                                )}
                            </div>
                            <div className="w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                    Nomor Wbs
                                </label>
                                <input
                                    value={values.WSBNo}
                                    onChange={changeHandler}
                                    name="WSBNo"
                                    className={
                                        (touched.WSBNo || buttonTouched) && errors.WSBNo
                                            ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                            : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                    }
                                    type="text"
                                />
                                {(touched.WSBNo || buttonTouched) && errors.WSBNo && (
                                    <p className="text-red-500 text-xs italic">{errors.WSBNo}</p>
                                )}
                            </div>
                        </div>
                        <div className="flex flex-wrap -mx-3 mb-6">
                            <div className="w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                    Priority *
                                </label>
                                <div className="inline-block relative w-full  ">
                                    <select
                                        value={values.Priority}
                                        onChange={changeHandler}
                                        name="Priority"
                                        // className=" appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                                        className={
                                            (touched.Priority || buttonTouched) && errors.Priority
                                                ? "block appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                : "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        }
                                    >
                                        <option defaultValue disabled value="" hidden>
                                            -- Pilih Data --
                                        </option>
                                        <option value="P1">P1</option>
                                        <option value="P2">P2</option>
                                        <option value="P3">P3</option>
                                    </select>
                                    <div
                                        className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                        <svg
                                            className="fill-current h-4 w-4"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                        >
                                            <path
                                                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                                        </svg>
                                    </div>
                                    {(touched.Priority || buttonTouched) && errors.Priority && (
                                        <p className="text-red-500 text-xs italic">
                                            {errors.Priority}
                                        </p>
                                    )}
                                </div>
                            </div>
                            <div className="w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                    Tanggal *
                                </label>
                                <DatePicker
                                    className={
                                        !isValidTanggal
                                            ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                            : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                    }
                                    disabled={values.Priority !== "P3"}
                                    selected={Tanggal}
                                    onChange={(date) => {
                                        setTanggal(date);
                                        setIsValidTanggal(true);
                                        if (showModalEdit) {
                                            setDateChanged(true);
                                        }
                                    }}
                                />
                                {!isValidTanggal && (
                                    <p className="text-red-500 text-xs italic">
                                        Tanggal pengajuan wajib diisi
                                    </p>
                                )}
                            </div>
                        </div>
                        <div className="flex flex-wrap -mx-3 mb-6">
                            <div className="w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                    Tanggal Incoming *
                                </label>
                                <DatePicker
                                    className={
                                        "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                    }
                                    selected={IncomingDate}
                                    onChange={(date) => {
                                        setIncomingDate(date);
                                    }}
                                />
                            </div>
                            <div className="w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                    Shipping Manifest
                                </label>
                                <input
                                    value={values.ShippingManifest}
                                    onChange={changeHandler}
                                    name="ShippingManifest"
                                    className={
                                        (touched.ShippingManifest || buttonTouched) &&
                                        errors.ShippingManifest
                                            ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                            : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                    }
                                    type="text"
                                />
                                {(touched.ShippingManifest || buttonTouched) &&
                                    errors.ShippingManifest && (
                                        <p className="text-red-500 text-xs italic">
                                            {errors.ShippingManifest}
                                        </p>
                                    )}
                            </div>
                        </div>
                    </div>
                    {indexSelected > -1 && (
                        <div className="p-4">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                Activity
                            </label>
                            {indexSelected > -1 &&
                                values.Activity &&
                                values.Activity.map(
                                    ({Name, DetailActivity}, index) => {
                                        if (DetailActivity !== null)
                                            return (
                                                <>
                                                    <div key={index} className="flex flex-wrap -mx-3 ">
                                                        <div className="w-full px-3">
                                                            <input
                                                                type="checkbox"
                                                                id={`custom-checkbox-${index}`}
                                                                name={Name}
                                                                checked={
                                                                    values.Activity[index]
                                                                        .Checked
                                                                }
                                                                onChange={(e) => {
                                                                    let tempdata = JSON.parse(
                                                                        JSON.stringify(values.Activity)
                                                                    );
                                                                    tempdata[indexSelected].Activity[
                                                                        index
                                                                        ].Checked =
                                                                        !tempdata[index].Activity[index].Checked;
                                                                    changeHandlerActivity(tempdata);
                                                                }}
                                                                className="mr-2"
                                                            />
                                                            <label htmlFor={`custom-checkbox-${index}`}>
                                                                {Name.replaceAll("_", " ")}
                                                            </label>
                                                        </div>
                                                    </div>
                                                    {DetailActivity && (
                                                        <div className="flex flex-wrap ml-7 mr-3">
                                                            <div className="w-full px-3">
                                                                <ul className="list-disc">
                                                                    {DetailActivity.map((subItem, subIndex) => (
                                                                        <div className="w-full px-3">
                                                                            <input
                                                                                type="checkbox"
                                                                                id={`custom-checkbox-${index}`}
                                                                                name={Name}
                                                                                value={Name}
                                                                                checked={
                                                                                    values.Activity[index].DetailActivity[subIndex].Checked
                                                                                }
                                                                                onChange={(e) => {
                                                                                    let tempdata = JSON.parse(JSON.stringify(values.Activity));
                                                                                    console.log(tempdata)
                                                                                    tempdata[index].DetailActivity[subIndex].Checked = !tempdata[index].DetailActivity[subIndex].Checked;
                                                                                    changeHandlerActivity(tempdata);
                                                                                }}
                                                                                className="mr-2"
                                                                            />
                                                                            <label htmlFor={`custom-checkbox-${index}`}>
                                                                                {subItem.Surname.replaceAll("_", " ")}
                                                                            </label>
                                                                        </div>
                                                                    ))}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    )}
                                                </>
                                            );
                                    }
                                )}
                        </div>
                    )}
                </div>
            </>
        );
    }
};

export default JobRequestPage;
